import styled from 'styled-components'

export const CategoryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
	flex-wrap: wrap;
  margin-bottom: 1.5rem;
	min-width: calc(100% + 1rem);
  max-width: calc(100% + 1rem);
  flex-direction: row;
	margin-right: 1rem;

	@media (min-width: 60rem) {
    padding-bottom: 0;
    overflow-x: unset;
    margin: 0;
    padding: 0;
		min-width: 100%;
  	max-width: 100%;
    margin-bottom: 2rem;
		flex-direction: row;
  }
`

export const ListWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  box-sizing: border-box;
	flex-direction: row;
	margin: 0;
	padding: 0 1rem 1rem 0;
  min-width: 100%;
  max-width: 100%;
  gap: 1.5rem;
  overflow-x: auto;

  &:last-child {
    margin-bottom: 0;
	}

	@media (min-width: 60rem) {
    flex-wrap: wrap;
  }
`

export const H2 = styled.h2`
  margin: 0;
  padding: 0;
  min-width: calc(100% - 1rem);
  border-bottom: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textNinethColor) || '#e2e2e2'} .063rem solid;
  padding-bottom: 1rem;
	padding-right: 4rem;
  margin-bottom: 1rem;
  color: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.textHighlightColor) || '#333'};
  font-size: 1.25rem;
  position: relative;

  > span {
    font-size: .8rem;
    line-height: 1.25rem;
    display: flex;
    justify-content: center;
    max-height: 1.25rem;
    position: absolute;
    right: 0;
    top: .3rem;
    color: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.primaryColor) || '#333'};

    > span {
      margin-left: .2rem;
    }

    @media (min-width: 60rem) {
      display: none;
    }
  }

  @media (min-width: 60rem) {
    margin-bottom: 2rem;
		min-width: 100%;
		max-width: 100%;
  }
`

export const EmptyMenu = styled.div`
	margin: 0 auto;
	color: ${props => (props.theme && props.theme.main && props.theme.main.general && props.theme.main.general.titleColor) || '#333'};
`;

export const EmptyMenuTitle = styled.h5`
	text-align: center;
  font-size: 1.125rem;
  color: inherit;
  margin: 0 0 1rem 0;
`;

export const EmptyMenuMessage = styled.p`
  color: inherit;
  opacity: .75;
  margin: 0;
	text-align: center;
`;

export const Span = styled.span``
